import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./login.css";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import Modal from 'react-bootstrap/Modal';
function RegisterIds() {
    // const location = useLocation();
    // const currentPath = location.pathname;
    const navigate = useNavigate();
    const termids = localStorage.getItem('termid');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [emailVerificationError, setEmailVerificationError] = useState('');
    const [emailVerified, setEmailVerified] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [isVerifying2, setIsVerifying2] = useState(false);
    const [submitloader, setSubmitloader] = useState(false);
    const [show, setShow] = useState(false);
    const [otpResendTimer, setOtpResendTimer] = useState(0);
    const [timerActive, setTimerActive] = useState(false);
    const [generalData, setgeneraldata] = useState([]);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

    const scriptRef = useRef(null);
    
    // Replace with your actual site key
    const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    // Load reCAPTCHA script dynamically
    useEffect(() => {
        const loadRecaptcha = () => {
        // Check if site key is available
        if (!RECAPTCHA_SITE_KEY) {
            console.error('reCAPTCHA site key not found in environment variables');
            return;
        }

        // Check if reCAPTCHA is already loaded
        if (window.grecaptcha) {
            setIsRecaptchaLoaded(true);
            return;
        }

        // Create and load the script
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.async = true;
        script.defer = true;
        
        script.onload = () => {
            window.grecaptcha.ready(() => {
            setIsRecaptchaLoaded(true);
            });
        };

        document.head.appendChild(script);
        scriptRef.current = script;
        };

        loadRecaptcha();

        // Cleanup function to remove script when component unmounts
        return () => {
        if (scriptRef.current) {
            document.head.removeChild(scriptRef.current);
        }
        };
    }, [RECAPTCHA_SITE_KEY]);

    // Execute reCAPTCHA
    const executeRecaptcha = async (action = 'submit') => {
        if (!RECAPTCHA_SITE_KEY) {
        console.error('reCAPTCHA site key not found in environment variables');
        return null;
        }

        if (!isRecaptchaLoaded || !window.grecaptcha) {
        console.error('reCAPTCHA not loaded yet');
        return null;
        }

        try {
        const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
        return token;
        } catch (error) {
        console.error('Error executing reCAPTCHA:', error);
        return null;
        }
    };

    useEffect(() => {
        const fetchsetsData = async () => {
        try {
            const response = await apiService.getRequest('/general-settings');
            if(response.success === true){
                setgeneraldata(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }
        };
        fetchsetsData();
    }, []);
    
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token === "undefined") {
        } else if (token){
            navigate('/dashboard');
        }
      }, [navigate]);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    useEffect(() => {
        let interval;
        if (timerActive && otpResendTimer > 0) {
          interval = setInterval(() => {
            setOtpResendTimer((prevTime) => prevTime - 1);
          }, 1000);
        } else if (otpResendTimer === 0) {
          setTimerActive(false);
          setEmailVerificationError("");
        }
        return () => clearInterval(interval);
      }, [timerActive, otpResendTimer]);
    
      const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        user_type: 'job_seeker',
        terms_id: termids,
    });
        const [errors, setErrors] = useState({});
        const [errorMessage, setErrorMessage] = useState('');
        
        
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    
        if (name === 'email') {
            setEmailVerificationError('');
            setOtpSent(false);
        }

        setFormData({ ...formData, [name]: value });
    };
    const validateForm = () => {
        const newErrors = {};

        // Check for empty fields
        Object.keys(formData).forEach((key) => {
            if (!formData[key]) {
                newErrors[key] = `${key.replace('_', ' ')} is required`;
            }else{
                if (key === "first_name" && formData[key].length < 3) {
                    newErrors[key] = "First Name must be at least 3 characters long";
                }else if (key === "first_name" && formData[key].length > 200) {
                    newErrors[key] = ['First Name must be less than 200 characters long.'];
                }
                if (key === "last_name" && formData[key].length > 200) {
                    newErrors[key] = ['Last Name must be less than 200 characters long.'];
                }
            }
        });

        // Additional validation for specific fields
        if (formData.password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match!';
        }

        const password = formData.password;
        const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
        if (!passwordFormat.test(password)) {
            newErrors.password = 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and any one special character.';
        }

        const email = formData.email;
        const emailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailFormat.test(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }

        if (!emailVerified) {
            newErrors.email = 'Please verify your email before proceeding.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
        // Send OTP API call
        const handleSendOtp = async () => {
            setIsVerifying(true);
            try {
                const response = await apiService.postRequest('auth/send-otp', { email: formData.email });
                if (response && response.success) {
                    setOtpSent(true);
                    setErrors({});
                    setEmailVerificationError('');
                    toast("OTP sent to Your Email!");
                    setTimerActive(false);
                }else {
                    setEmailVerificationError(response.message);
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    if(response && response.remaining_seconds){
                        setTimerActive(true);
                        setOtpResendTimer(response.remaining_seconds);
                    }
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                  } 
            } catch (error) {
                console(error,"err")
            }finally {
                setIsVerifying(false);
            }
        };
        // Verify OTP API call
        const handleVerifyOtp = async () => {
            setIsVerifying2(true);
            try {
                const response = await apiService.postRequest('auth/verify-otp', { email: formData.email, otp });
                if (response && response.success) {
                    setEmailVerified(true);
                    setOtpError('');
                    setErrors({});
                    setTimerActive(false);
                    setOtpResendTimer(0);
                    setEmailVerificationError("");
                } else {
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    setOtpError(response.message);
                    setEmailVerified(false);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (error) {
                setOtpError('An unexpected error occurred during OTP verification.');
            }finally {
                setIsVerifying2(false);
            }
        };
        const handleClose = async () => {
            try {
                await apiService.postRequest('/auth/logout');
                localStorage.removeItem('token');
                localStorage.removeItem('docuTemplateId')
                localStorage.removeItem('role');
                localStorage.removeItem('userid');
                navigate('/login');
            } catch (error) {
                console.error('Logout error:', error);
            }
            setShow(false);
        };
      const handleSubmit = async (e) => {
        e.preventDefault();
        const token = await executeRecaptcha('register');
        if (!token) {
            alert('reCAPTCHA verification failed. Please try again.');
            return;
        }
        if (!validateForm()) {
            if (formData.password !== confirmPassword) {
                setErrorMessage('Passwords do not match!');
                return;
              }else {
                    setErrorMessage('Please fix the errors before proceeding.');
                }
            return;
        }
        
          setSubmitloader(true);
          try {
            const jsonParams = {
                "email": formData.email,
                "password": formData.password,
                "first_name": formData.first_name,
                "last_name": formData.last_name,
                "user_type": 'job_seeker',
                "terms_id": termids,
                "recaptcha_token": token,
              };
              const response = await apiService.postRequest('auth/register', jsonParams);

              // Check if the response indicates success
              if (response && response.success === true) {
                const { session_timeout, session_warning } = response.data;
                const expiryTime = Date.now() + session_timeout * 60 * 1000;
                const { token } = response.data; 
                const { user_type } = response.data;
                const { user_id } = response.data;
                localStorage.setItem('token', token);
                localStorage.setItem('role', user_type);
                localStorage.setItem('userid', user_id);
                localStorage.setItem("sessionExpiry", expiryTime.toString());
                localStorage.setItem("sessionWarning", session_warning.toString());
                localStorage.removeItem('termid');
                setErrors({});
                setErrorMessage('');
                setShow(true);
              } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                  setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
              }
            } catch (error) {
                console.log("err",error);
            }finally {
                setSubmitloader(false); // Stop loader
            }
        };
        const sanitizeAndDisplayHTML = (html) => {
            const sanitizedHTML = html
            return sanitizedHTML;
        };
  return (
    <Grid size={{xs:12}} container justifyContent="center" className="registerdetailsmain">
        <Grid size={{lg:8,sm:10,xs:11}} container alignItems="flex-start" justifyContent="center" className="regisdetailwhite">
            <Grid size={{xs:12}} container justifyContent="center">
                {generalData && generalData.site_logo ? <img onClick={() =>{navigate("/")}} src={generalData.site_logo} alt=''/> :
                  <img onClick={() =>{navigate("/")}} src={require("../../assets/logo.svg").default} alt=''/>
                }
                <h2>Create Account</h2>
                <form className='w-100' onSubmit={handleSubmit}>
                    <Grid size={{lg:12,xs:12}} container justifyContent="center" className="regiter_inputs">
                        <Grid size={{sm:8, xs:12}} container flexDirection="column">
                            <span>Email<small className='red_starimpo'>*</small></span>
                            <input type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                disabled={emailVerified}
                            />
                            {errors.email && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.email) }} />}
                        </Grid>
                        <Grid size={{sm:8, xs:12}} container alignItems="flex-end">
                            {(!otpSent && !emailVerificationError) && (
                                <button type="button" className='registersendbtn2 mb-2' onClick={handleSendOtp}>
                                    {isVerifying ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Get OTP'}
                                </button>
                            )}
                            {emailVerificationError && <p style={{ color: 'red', marginTop: '10px',width : "100%" }}>{emailVerificationError}</p>}
                            {timerActive ?
                                <small className='resend_otpsmallTimer'>{timerActive ? `Resend OTP in ${formatTime(otpResendTimer)}` : ''}</small>:<>
                                {otpSent && (emailVerified === false) ? (
                                    <button className='registersendbtn1 mb-2 ms-2 px-0' type="button" onClick={handleSendOtp}>
                                        {isVerifying ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : 'Resend OTP'}
                                    </button>
                                ) : (emailVerified === true) ? <small className='verified_small'><FontAwesomeIcon icon={faCircleCheck} /> Verified</small> : ""}
                            </>}
                        </Grid>
                        {(otpSent) && (emailVerified === false) ?  (
                            <>
                            <Grid size={{ sm: 8, xs: 12 }} container flexDirection="column">
                                <span>Enter OTP ( Sent to Email )<small className='red_starimpo'>*</small></span>
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="------" maxLength={6} className='otp_input'
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                />
                            </Grid>
                            <Grid size={{sm:8, xs:12}} container alignItems="flex-end">
                            <button type="button" className='registersendbtn2 mb-2' onClick={handleVerifyOtp}>{isVerifying2 ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Verify OTP'}</button>
                            {otpError && <p style={{ color: 'red',marginLeft:'10px' }}>{otpError}</p>}
                        </Grid>
                        </>
                        ):""}
                        
                        {emailVerified && <>
                            <Grid size={{sm:8, xs:12}} container flexDirection="column">
                            <span>First Name<small className='red_starimpo'>*</small></span>
                            <input
                                type="text"
                                name="first_name"
                                minLength="3"
                                maxLength="201"
                                value={formData.first_name}
                                onChange={handleInputChange}
                                onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                            />
                            {errors.first_name && <p style={{color:"Red"}}>{errors.first_name}</p>}
                        </Grid>
                        <Grid size={{sm:8, xs:12}} container flexDirection="column">
                            <span>Last Name<small className='red_starimpo'>*</small></span>
                            <input
                                type="text"
                                name="last_name"
                                maxLength="201"
                                value={formData.last_name}
                                onChange={handleInputChange}
                                onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                            />
                            {errors.last_name && <p style={{color:"Red"}}>{errors.last_name}</p>}
                        </Grid>
                        <Grid size={{sm:8, xs:12}} container flexDirection="column" alignItems="flex-start">
                            <span>Password<small className='red_starimpo'>*</small></span>
                            <div className='d-flex input_witheye'>
                                <input
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    type={passwordVisible ? 'text' : 'password'}
                                    placeholder="Abcd123#"
                                    style={{ width: '100%', paddingRight: '40px' }}
                                />
                                <button type="button" onClick={togglePasswordVisibility}>
                                    {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                </button>
                            </div>
                            {errors.password && <p style={{color:"Red"}}>{errors.password}</p>}
                        </Grid>
                        <Grid size={{sm:8, xs:12}} container flexDirection="column">
                            <span>Confirm Password<small className='red_starimpo'>*</small></span>
                            <div className='d-flex input_witheye'>
                                <input
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    type={passwordVisible2 ? 'text' : 'password'}
                                    placeholder="Abcd123#"
                                    style={{ width: '100%', paddingRight: '40px' }}
                                />
                                <button type="button" onClick={togglePasswordVisibility2}>
                                    {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                </button>
                            </div>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </Grid>
                        <Grid size={{sm:12, xs:12}} container justifyContent="space-between" className="mt-5">
                            <button className='registersendbtn1' type="button" onClick={() =>{navigate("/")}}>Cancel</button>
                            <button className='registersendbtn2' type="submit" >{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save & Next'}</button>
                        </Grid>
                        </>}
                    </Grid>
                </form>
                <Modal
                    show={show} 
                    onHide={handleClose}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Congratulation!</h3>
                            <small>You have successfully created your BenchTrack account.</small>
                            <button onClick={()=> navigate("/registration/personal-questions")}>Go to Next</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </Grid>
        </Grid>
    </Grid>
  )
}

export default RegisterIds
